<template>
  <div class="home" v-loading="loading">
    <swiper id="swiperBox" v-bind:options="swiperOption" ref="mySwiper">
      <swiper-slide class="swiper-slide slide-one">
        <div class="hero-content">
          <h1>华欣焱</h1>
          <p class="hero-subtitle">立足新起点 · 开创新高度</p>
          <p class="hero-desc">追求卓越，创造一流，放眼未来</p>
          <div class="hero-actions">
            <router-link class="primary-action" to="/product">了解产品</router-link>
            <router-link class="ghost-action" to="/goin">走进华欣焱</router-link>
          </div>
          <div class="hero-metrics">
            <div>
              <strong>智慧化</strong>
              <span>平台能力</span>
            </div>
            <div>
              <strong>专业化</strong>
              <span>项目服务</span>
            </div>
            <div>
              <strong>一体化</strong>
              <span>解决方案</span>
            </div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide slide-two">
        <div class="section-heading case-heading">
          <h2>经典案例</h2>
        </div>
        <ul
          class="case-item"
          :class="{ 'case-single': displayedCaseList.length === 1 }"
          v-if="displayedCaseList.length"
        >
          <li
            v-for="(item,index) in displayedCaseList"
            :key="index"
            :class="{ 'case-featured': index === 0 && displayedCaseList.length > 1 }"
            v-lazy:background-image="imgserver + item.img"
          >
            <router-link
              class="text-decoration"
              :to="{ name: 'casedetails', params: { id: item.id }}"
            >
              <div class="case-card-info">
                <h3>{{ getTitle(item) }}</h3>
              </div>
              <div class="case-item-hover">
                <p class="hover-title">{{ getTitle(item) }}</p>
                <div class="more">
                  <span>查看详情</span>
                  <i class="el-icon-right"></i>
                </div>
              </div>
            </router-link>
          </li>
        </ul>
        <div class="case-empty" v-else-if="!loading">
          <i class="el-icon-folder-opened"></i>
          <p>暂无案例数据</p>
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide slide-three">
        <div class="section-heading">
          <p>Latest News</p>
          <h2>最新资讯</h2>
          <p>关注企业动态，洞察行业趋势</p>
        </div>
        <div class="news-content">
          <article class="news-content-item" v-for="(news,i) in displayedNewsList" :key="i">
            <router-link
              class="text-decoration"
              :to="{ name: 'newsdetails', params: { id: news.id }}"
            >
              <div class="item-img" v-lazy:background-image="imgserver + news.img">
                <span class="news-tag">NEWS</span>
              </div>
              <div class="item-content">
                <div class="news-card-top">
                  <span>公司新闻</span>
                  <time>{{ news.createTime }}</time>
                </div>
                <h3>{{ getTitle(news) }}</h3>
                <p>{{ formatContent(news.content) }}</p>
                <span class="news-more">阅读详情 <i class="el-icon-right"></i></span>
              </div>
            </router-link>
          </article>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>
 
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "HelloWorld",
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      loading: true,
      caseList: [],
      newsList: [],
      swiperOption: {
        notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        direction: "vertical", //水平方向移动
        grabCursor: true, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
        autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
        slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        mousewheel: true, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
        mousewheelControl: true, //同上
        height: window.innerHeight - 60, // 高度设置，占满设备高度
        resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
        observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新

        // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
        //debugger: true,

        // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
        on: {
          //监听滑动切换事件，返回swiper对象
          // slideChange: () => {
          //   let swiper = this.$refs.mySwiper.swiper;
          //   //console.log(swiper.activeIndex); //滑动打印当前索引
          //   if (swiper.activeIndex === this.list.length - 1) {
          //     //到最后一个加载更多数据
          //     let newList = [];
          //     let listLength = this.list.length;
          //     for (let i = 0; i < 10; i++) {
          //       newList.push(listLength + i);
          //     }
          //     this.list = this.list.concat(newList);
          //   }
          // }
        }
      }
    };
  },
  created() {},
  // 如果你需要得到当前的swiper对象来做一些事情，你可以像下面这样定义一个方法属性来获取当前的swiper对象，同时notNextTick必须为true
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    displayedCaseList() {
      return this.caseList.slice(0, 5);
    },
    displayedNewsList() {
      return this.newsList.slice(0, 3);
    }
  },
  methods: {
    getTitle(item) {
      return item.title || item.Title || "";
    },
    formatContent(content) {
      if (!content) return "";
      return content.replace(/<[^>]+>/g, "").replace(/&nbsp;/g, " ").trim();
    }
  },
  mounted() {
    this.$http
      .all([
        this.$http.get("Case"),
        this.$http.get(`News?type=1&num=3`),
      ])
      .then(
        this.$http.spread((responseCases, responseNews) => {
          this.caseList = responseCases.result;
          this.newsList = responseNews.result;
        })
      )
      .catch(() => {
        this.caseList = [];
        this.newsList = [];
      })
      .finally(() => {
        this.loading = false;
      });
  }
};
</script>
 
<style lang="scss" scoped>
.home {
  background: #071421;
}

.swiper-slide {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  padding: 56px 24px;
  box-sizing: border-box;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(110deg, rgba(5, 17, 31, 0.9), rgba(10, 42, 70, 0.68) 48%, rgba(5, 15, 27, 0.78));
    z-index: 0;
  }

  &::after {
    content: "";
    position: absolute;
    right: 8%;
    top: 12%;
    width: 280px;
    height: 280px;
    border: 1px solid rgba(255, 255, 255, 0.16);
    transform: rotate(18deg);
    z-index: 0;
  }

  > * {
    position: relative;
    z-index: 1;
  }
}

.hero-content {
  width: min(1120px, 100%);
  color: #fff;
  padding-left: 4px;
}

.hero-content h1 {
  margin-top: 0;
  font-size: 62px;
  line-height: 1.06;
  font-weight: 800;
  letter-spacing: 0;
  text-shadow: 0 8px 24px rgba(0, 0, 0, 0.22);
}

.hero-subtitle {
  margin-top: 16px;
  max-width: 680px;
  font-size: 28px;
  line-height: 1.35;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.92);
  text-shadow: 0 5px 16px rgba(0, 0, 0, 0.18);
}

.hero-desc {
  max-width: 520px;
  margin-top: 18px;
  color: rgba(255, 255, 255, 0.72);
  font-size: 16px;
  line-height: 1.8;
}

.hero-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 34px;
}

.primary-action,
.ghost-action {
  min-width: 136px;
  min-height: 44px;
  padding: 0 24px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  text-decoration: none;
  transition: transform 0.25s ease, background 0.25s ease, border-color 0.25s ease;
}

.primary-action {
  background: #e43d30;
  color: #fff;
  box-shadow: 0 14px 30px rgba(228, 61, 48, 0.28);
}

.ghost-action {
  border: 1px solid rgba(255, 255, 255, 0.45);
  color: #fff;
  background: rgba(255, 255, 255, 0.08);
}

.primary-action:hover,
.ghost-action:hover {
  transform: translateY(-2px);
}

.hero-metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  max-width: 680px;
  margin-top: 54px;

  div {
    padding: 18px 20px;
    border: 1px solid rgba(255, 255, 255, 0.18);
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(8px);
    border-radius: 8px;
  }

  strong,
  span {
    display: block;
  }

  strong {
    font-size: 24px;
    line-height: 1.3;
    color: #fff;
  }

  span {
    margin-top: 6px;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.72);
  }
}

.section-heading {
  width: min(1120px, 100%);
  text-align: center;
  color: #fff;

  span,
  > p:first-child {
    display: block;
    color: #86d6ff;
    font-size: 15px;
    font-weight: 600;
    text-transform: uppercase;
  }

  h2 {
    margin-top: 8px;
    font-size: 44px;
    line-height: 1.2;
    font-weight: 700;
  }

  p {
    margin-top: 10px;
    color: rgba(255, 255, 255, 0.74);
    font-size: 17px;
  }
}

.case-heading {
  text-align: center;
}

//经典案例
.case-item {
  width: min(920px, 100%);
  max-height: 388px;
  overflow: hidden;
  margin: 24px auto 0;
  display: grid;
  grid-template-columns: 1.15fr repeat(2, minmax(0, 1fr));
  grid-auto-rows: 184px;
  gap: 14px;

  &.case-single {
    width: min(420px, 100%);
    grid-template-columns: 1fr;
    grid-auto-rows: 188px;
  }

  li {
    list-style: none;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    position: relative;
    overflow: hidden;
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.14);
    box-shadow: 0 20px 45px rgba(0, 0, 0, 0.24);
    transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;

    &::before {
      content: "";
      position: absolute;
      inset: 0;
      background: linear-gradient(180deg, rgba(5, 17, 31, 0.02) 24%, rgba(5, 17, 31, 0.72));
      transition: opacity 0.3s ease;
    }

    &::after {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 4px;
      background: linear-gradient(90deg, #d63a30, #1d87c9);
      opacity: 0.88;
      z-index: 1;
    }

    &.case-featured {
      grid-row: span 2;

      .case-card-info h3 {
        font-size: 24px;
        -webkit-line-clamp: 3;
      }
    }

    &:hover {
      transform: translateY(-6px);
      border-color: rgba(255, 255, 255, 0.32);
      box-shadow: 0 28px 54px rgba(0, 0, 0, 0.32);

      .case-card-info {
        opacity: 0;
        transform: translateY(10px);
      }

      .case-item-hover {
        opacity: 1;
      }
    }
  }

  .text-decoration {
    display: block;
    width: 100%;
    height: 100%;
  }
}

.case-card-info {
  position: absolute;
  left: 22px;
  right: 22px;
  bottom: 18px;
  z-index: 1;
  color: #fff;
  transition: opacity 0.25s ease, transform 0.25s ease;

  h3 {
    font-size: 18px;
    line-height: 1.45;
    font-weight: 700;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}

//经典案例hover
.case-item-hover {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  overflow: hidden;
  padding: 22px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background: linear-gradient(180deg, rgba(6, 29, 48, 0.15), rgba(228, 61, 48, 0.9));
  transition: opacity 0.3s ease;
  z-index: 2;

  .hover-title {
    color: #fff;
    font-size: 18px;
    line-height: 1.45;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    font-weight: 600;
  }

  .more {
    width: fit-content;
    min-height: 34px;
    padding: 0 14px;
    margin-top: 14px;
    border: 1px solid rgba(255, 255, 255, 0.8);
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: #fff;
    font-size: 13px;
    font-weight: 600;
  }
}

.case-empty {
  width: min(1120px, 100%);
  min-height: 260px;
  margin-top: 34px;
  border: 1px dashed rgba(255, 255, 255, 0.28);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.76);

  i {
    font-size: 42px;
    color: rgba(255, 255, 255, 0.56);
  }

  p {
    margin-top: 12px;
    font-size: 16px;
  }
}

.slide-one {
  background: url(../assets/img/home_top.jpg) no-repeat center;
  background-size: cover;
}
.slide-two {
  background: url(../assets/img/home_do.jpg) no-repeat center;
  background-size: cover;
}
.slide-three {
  background: url(../assets/img/home_anli.jpg) no-repeat center;
  background-size: cover;
}
//最新资讯
.news-content {
  width: min(1120px, 100%);
  margin: 34px auto 0;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 22px;

  &-item {
    min-height: 408px;
    border-radius: 8px;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 20px 48px rgba(0, 0, 0, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.72);
    transition: transform 0.28s ease, box-shadow 0.28s ease, border-color 0.28s ease;

    &:hover {
      transform: translateY(-6px);
      border-color: rgba(214, 58, 48, 0.28);
      box-shadow: 0 28px 58px rgba(0, 0, 0, 0.28);

      .item-img::before {
        opacity: 0.2;
      }

      .news-more {
        color: #d63a30;
      }
    }

    .text-decoration {
      display: flex;
      flex-direction: column;
      height: 100%;
      color: inherit;
      text-decoration: none;
    }

    .item-img {
      position: relative;
      width: 100%;
      height: 184px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      background-color: #d9e7f1;

      &::before {
        content: "";
        position: absolute;
        inset: 0;
        background: #061d30;
        opacity: 0;
        transition: opacity 0.25s ease;
      }
    }

    .news-tag {
      position: absolute;
      left: 18px;
      top: 18px;
      min-height: 28px;
      padding: 0 12px;
      border-radius: 999px;
      display: inline-flex;
      align-items: center;
      background: rgba(214, 58, 48, 0.92);
      color: #fff;
      font-size: 12px;
      font-weight: 700;
    }

    .item-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      padding: 22px 24px 24px;
      box-sizing: border-box;
    }

    .news-card-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      color: #8495a8;
      font-size: 13px;

      span {
        color: #d63a30;
        font-weight: 700;
      }

      time {
        white-space: nowrap;
      }
    }

    h3 {
      margin-top: 12px;
      color: #142235;
      font-size: 21px;
      line-height: 1.45;
      min-height: 60px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    p {
      margin-top: 12px;
      color: #596779;
      font-size: 15px;
      line-height: 1.75;
      height: 76px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      white-space: normal !important;
      word-wrap: break-word;
    }

    .news-more {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      margin-top: auto;
      padding-top: 18px;
      color: #156da8;
      font-size: 14px;
      font-weight: 700;
      transition: color 0.25s ease;
    }
  }
}

@media (max-width: 1200px) {
  .case-item,
  .news-content,
  .hero-content,
  .section-heading,
  .case-empty {
    width: 92%;
  }
}

@media (max-width: 900px) {
  .swiper-slide {
    padding: 42px 18px;
  }

  .hero-content h1 {
    font-size: 50px;
  }

  .hero-subtitle {
    font-size: 24px;
  }

  .hero-metrics,
  .case-item,
  .news-content {
    grid-template-columns: 1fr;
  }

  .case-heading {
    text-align: center;
  }

  .hero-metrics {
    max-width: 100%;
  }

  .case-item {
    max-height: 360px;
    grid-auto-rows: 170px;

    li.case-featured {
      grid-row: span 1;
    }
  }

  .news-content {
    max-height: 460px;
    overflow: hidden;
  }
}

@media (max-width: 560px) {
  .hero-content h1 {
    font-size: 42px;
  }

  .hero-subtitle {
    font-size: 22px;
  }

  .hero-desc,
  .section-heading p {
    font-size: 15px;
  }

  .section-heading h2 {
    font-size: 34px;
  }

  .hero-metrics {
    margin-top: 32px;
  }
}
</style>
